module.exports = __webpack_public_path__ + "static/media/ticketHossHorizontal.4c1aa182.svg";